import TStrings from '../Reports.i18n';
import ModalTextRow from '~/components/ModalTextRow';
import BlankIcon from '~/components/icons/BlankIcon';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import RightCaretIcon from '~/components/icons/RightCaretIcon';
import { TemplateIndex } from '../Report.types';
import ClientsIcon from '~/components/icons/ClientsIcon';
import RevenueIcon from '~/components/icons/RevenueIcon';
import ClassesIcon from '~/components/icons/ClassesIcon';
import RevenueArrowIcon from '~/components/icons/RevenueArrowIcon';
import { FEATURE_INVOICES, useFeatures } from '~/lib/Features';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

type NewReportTemplateSelectorProps = {
    onReportTemplateSelected: (template: TemplateIndex) => void;
};

const DEFAULT_ICON_SIZE = 25;

const TemplateSelector = ({
    onReportTemplateSelected,
}: NewReportTemplateSelectorProps) => {
    const { isEnabled } = useFeatures();
    const invoicesEnabled = isEnabled(FEATURE_INVOICES);

    return (
        <div className="flex grow items-center flex-col">
            <div className="text-base font-semibold leading-6 text-gray-900">
                {TStrings.CREATE_REPORT_TITLE}
            </div>
            <div className="flex flex-col w-full mt-4">
                <ModalTextRow
                    text={TStrings.CREATE_BLANK_TEMPLATE_TITLE}
                    onClick={() =>
                        onReportTemplateSelected(TemplateIndex.BLANK_TEMPLATE)
                    }
                    leftIcon={
                        <div className="absolute text-primary-700">
                            <BlankIcon />
                        </div>
                    }
                    rightIcon={<RightCaretIcon />}
                />
                <ModalTextRow
                    text={TStrings.CREATE_LAST_MONTH_BOOKINGS_TEMPLATE_TITLE}
                    onClick={() =>
                        onReportTemplateSelected(
                            TemplateIndex.LAST_MONTH_BOOKINGS,
                        )
                    }
                    leftIcon={
                        <div className="absolute text-primary-700">
                            <CalendarDaysIcon width={DEFAULT_ICON_SIZE} />
                        </div>
                    }
                    rightIcon={<RightCaretIcon />}
                />
                <ModalTextRow
                    text={TStrings.CREATE_ALL_CLIENTS_TEMPLATE_TITLE}
                    onClick={() =>
                        onReportTemplateSelected(TemplateIndex.ALL_CLIENTS)
                    }
                    leftIcon={
                        <div className="absolute text-primary-700">
                            <ClientsIcon />
                        </div>
                    }
                    rightIcon={<RightCaretIcon />}
                />
                <ModalTextRow
                    text={TStrings.CREATE_REVENUE_PER_TYPE_TITLE}
                    onClick={() =>
                        onReportTemplateSelected(
                            TemplateIndex.REVENUE_PER_EVENT_TYPE,
                        )
                    }
                    leftIcon={
                        <div className="absolute text-primary-700">
                            <RevenueIcon />
                        </div>
                    }
                    rightIcon={<RightCaretIcon />}
                />
                <ModalTextRow
                    text={TStrings.CREATE_ALL_CLASSES_TEMPLATE_TITLE}
                    onClick={() =>
                        onReportTemplateSelected(TemplateIndex.ALL_CLASSES)
                    }
                    leftIcon={
                        <div className="absolute text-primary-700">
                            <ClassesIcon />
                        </div>
                    }
                    rightIcon={<RightCaretIcon />}
                />
                <ModalTextRow
                    text={TStrings.CREATE_REVENUE_TITLE}
                    onClick={() =>
                        onReportTemplateSelected(TemplateIndex.REVENUE)
                    }
                    leftIcon={
                        <div className="absolute text-primary-700">
                            <RevenueArrowIcon />
                        </div>
                    }
                    rightIcon={<RightCaretIcon />}
                />
                {invoicesEnabled && (
                    <ModalTextRow
                        text="All Invoices"
                        onClick={() =>
                            onReportTemplateSelected(TemplateIndex.ALL_INVOICES)
                        }
                        leftIcon={
                            <div className="absolute text-primary-700">
                                <DocumentTextIcon width={DEFAULT_ICON_SIZE} />
                            </div>
                        }
                        rightIcon={<RightCaretIcon />}
                    />
                )}
            </div>
        </div>
    );
};
export default TemplateSelector;
